module.exports = __webpack_public_path__ + "img/embellishment-right.6aeba6a2.svg";